"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableActionCopy_1 = require("../../../../../../shared/components/table_actions/TableActionCopy");
var BonusesList = /** @class */ (function (_super) {
    __extends(BonusesList, _super);
    function BonusesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    BonusesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                bonus_type_filter: data.bonus_type_filter,
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            bonus_type_filter: this.props.data.getBonusTypeFilter(),
            // currency_filter: this.props.data.getCurrencyFilter(),
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: ""
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    BonusesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    BonusesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    BonusesList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.SetIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    BonusesList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    BonusesList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    BonusesList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    BonusesList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    BonusesList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    BonusesList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    BonusesList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Брэнд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_bonus_type_title,
                key: this.props.data.dk_bonus_type_title,
                width: 200,
                filters: this.state.bonus_type_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.bonus_type_title.includes(value); },
            }, {
                title: 'Кол-во валют',
                dataIndex: this.props.data.dk_currency_count,
                key: this.props.data.dk_currency_count,
                width: 100,
                align: "center"
            }, {
                title: 'Кол-во языков',
                dataIndex: this.props.data.dk_language_count,
                key: this.props.data.dk_language_count,
                width: 100,
                align: "center"
            }, {
                title: 'Фриспины',
                dataIndex: this.props.data.dk_is_use_freespin,
                key: this.props.data.dk_is_use_freespin,
                width: 100,
                align: "center",
                render: function (text, record, idx) {
                    var is_use = "нет";
                    if (record.is_use_freespin) {
                        is_use = "да";
                    }
                    return (React.createElement("div", null, is_use));
                }
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 140,
                filters: [
                    { text: "Заблокирован", value: 'true' },
                    { text: "Разблокирован", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_locked === (value === 'true'); }
            }, {
                title: 'Устарел',
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
                filters: [
                    { text: "Устаревший", value: 'true' },
                    { text: "Актуальный", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_deprecated === (value === 'true'); }
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 250,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigBonusClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionCopy_1.default, { hint: "Клонировать", confirmText: "\u041A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onCloneData(record); } }))); },
                width: 120
            }];
    };
    ;
    BonusesList.prototype.onCloneData = function (record) {
        var _this = this;
        this.props.data.DoCloneBonusTemplates(record.key, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
    };
    // private onTagListClick(record: IBonusTemplatesListItem) {
    //     if (this.props.onTagsListClick) {
    //         this.props.onTagsListClick(record);
    //     }
    // }
    // private onTranslateBonusTemplateClick(record: IBonusTemplatesListItem) {
    //     if (this.props.onTranslateClick) {
    //         this.props.onTranslateClick(record);
    //     }
    // }
    BonusesList.prototype.onConfigBonusClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BonusesList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u043E\u043D\u0443\u0441 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BonusesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    BonusesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BonusesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    BonusesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return BonusesList;
}(React.Component));
exports.default = BonusesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/BonusTemplatesList.tsx
// module id = 1900
// module chunks = 0